import React from 'react';
import { ConfirmationModal, DataList } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';

const HomePageList: React.FC<{}> = () => {
	const {
		getVersionSupportedHomepageLayout,
		globalForceUpdate,
		turnGlobalForceUpdateOff,
		confirmationDialog,
		handleSubmitAlertCancel,
		handleSubmitAlertConfirmation,
		setSubmitConfirmationDialog,
		removeVersionLayouts,
		clearLocalStorageForConfig
	} = useService();

	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		setSubmitConfirmationDialog,
		removeVersionLayouts,
		clearLocalStorageForConfig
	});

	const actions = getActionList();

	return (
		<>
			{confirmationDialog.show && (
				<ConfirmationModal
					confirmationHeader={confirmationDialog.header}
					confirmationMessage={confirmationDialog.message}
					onClose={handleSubmitAlertCancel}
					confirmationDialogOnAgree={handleSubmitAlertConfirmation}
				/>
			)}
			<DataList
				fetchData={getVersionSupportedHomepageLayout}
				globalForceUpdate={globalForceUpdate}
				turnGlobalForceUpdateOff={turnGlobalForceUpdateOff}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.MIN_APP_VERSION}
				initialSortDirection='ASC'
				initialSortIndex={1}
			/>
		</>
	);
};

export default HomePageList;
